import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingButton from 'y4/components/common/LoadingButton';
import y from 'y4/Utils';
import { run as runCommand } from '../Executer';
import { useNavigate } from 'react-router-dom';
import { FormCheck } from 'react-bootstrap';

const ButtonPanel = ({ form, panel }) => {
  const navigate = useNavigate();
  const ias = y.gpv(panel, 'option.innerAttributes');

  //Dispatch selectionChanged
  const buttonClicked = d => {
    form.eventTarget.dispatchEvent(
      new CustomEvent('form-event', {
        detail: {
          event: 'buttonClicked',
          panel,
          form,
          data: d
        }
      })
    );
  };

  function click(button) {
    if (button.command) {
      return runCommand({
        form,
        panel,
        command: button.command,
        params: button.params,
        javascript: button.javascript,
        successMessage: button.successMessage,
        successCommand: button.successCommand,
        navigate: navigate
      });
    } else {
      buttonClicked(button);
    }
  }

  //Listen events
  useEffect(() => {
    form.eventTarget.addEventListener('form-event', e => {
      const event = e.detail.event;
      const path = 'events.listen' + y.firstCharToUpper(event);
      const script = y.gpv(panel, path);
      if (script) {
        const f = Function('y', 'source', 'target', script);
        f(y, e.detail, {
          form,
          panel,
          click
        });
      }
    });
  }, [form.eventTarget]);

  return (
    <div {...ias}>
      {panel.buttons.map((button, index) => {
        return button.type == 'checkbox' ? (
          <FormCheck
            type="checkbox"
            className="pt-2 m-0"
            id={button.id}
            label={button.text}
          />
        ) : (
          <LoadingButton
            key={index}
            loadingText={button.waitingText}
            onClick={() => {
              return click(button);
            }}
            {...button.attributes}
          >
            {button.text}
          </LoadingButton>
        );
      })}
    </div>
  );
};

ButtonPanel.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object
};

export default ButtonPanel;
